// Framer Motion Animations Utility
// Import this file in any component to use these animations

// Basic Animation Variants
export const fadeInUp = {
  hidden: { 
    opacity: 0, 
    y: 50,
    scale: 0.9
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

export const fadeInDown = {
  hidden: { 
    opacity: 0, 
    y: -50,
    scale: 0.9
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

export const fadeInLeft = {
  hidden: { 
    opacity: 0, 
    x: 0,
    scale: 0.9
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

export const fadeInRight = {
  hidden: { 
    opacity: 0, 
    x: 0,
    scale: 0.9
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

// EMI Info Section Specific Animations
export const cardVariantsLeft = {
  hidden: { 
    opacity: 0, 
    x: 0,
    scale: 0.8
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 1.2,
      ease: "easeOut"
    }
  }
};

export const cardVariantsRight = {
  hidden: { 
    opacity: 0, 
    x: 0,
    scale: 0.8
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 1.2,
      ease: "easeOut"
    }
  }
};

export const cardVariants = {
  hidden: { 
    opacity: 0, 
    y: 50,
    scale: 0.9
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

export const hoverVariants = {
  hover: {
    y: -15,
    scale: 1.05,
    rotateY: 5,
    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
    transition: {
      duration: 0.4,
      ease: "easeInOut"
    }
  }
};

export const textVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      delay: 0.3
    }
  }
};

export const listItemVariants = {
  hidden: { opacity: 0, x: -30 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

export const factorItemHover = {
  hover: {
    scale: 1.05,
    y: -8,
    rotateX: 2,
    boxShadow: "0 15px 30px rgba(79, 195, 247, 0.2)",
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};

export const exampleBoxHover = {
  hover: {
    scale: 1.03,
    y: -5,
    boxShadow: "0 10px 25px rgba(79, 195, 247, 0.15)",
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};

// Stagger Animation Variants
export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1
    }
  }
};

export const staggerItem = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

// Hover Animation Variants
export const hoverScale = {
  hover: {
    scale: 1.05,
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};

export const hoverLift = {
  hover: {
    y: -10,
    scale: 1.02,
    boxShadow: "0 15px 35px rgba(0, 0, 0, 0.1)",
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};

export const hoverRotate = {
  hover: {
    rotate: 5,
    scale: 1.1,
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};

// Card Animation Variants
export const cardHover = {
  hover: {
    y: -10,
    scale: 1.02,
    boxShadow: "0 15px 35px rgba(40, 55, 130, 0.3)",
    transition: {
      duration: 0.2,
      ease: "easeInOut"
    }
  }
};

// Text Animation Variants
export const textStagger = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.3
    }
  }
};

// Button Animation Variants
export const buttonVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  },
  hover: {
    scale: 1.05,
    transition: {
      duration: 0.2,
      ease: "easeInOut"
    }
  },
  tap: {
    scale: 0.95,
    transition: {
      duration: 0.1
    }
  }
};

// Icon Animation Variants
export const iconVariants = {
  hidden: { opacity: 0, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  },
  hover: {
    scale: 1.2,
    rotate: 5,
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};

// Page Transition Variants
export const pageVariants = {
  initial: {
    opacity: 0,
    x: 0
  },
  in: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  },
  out: {
    opacity: 0,
    x: 0,
    transition: {
      duration: 0.4,
      ease: "easeIn"
    }
  }
};

// Modal Animation Variants
export const modalVariants = {
  hidden: {
    opacity: 0,
    scale: 0.8,
    y: 50
  },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  },
  exit: {
    opacity: 0,
    scale: 0.8,
    y: 50,
    transition: {
      duration: 0.3,
      ease: "easeIn"
    }
  }
};

// Loading Animation Variants
export const loadingVariants = {
  animate: {
    rotate: 360,
    transition: {
      duration: 1,
      repeat: Infinity,
      ease: "linear"
    }
  }
};

// Pulse Animation Variants
export const pulseVariants = {
  animate: {
    scale: [1, 1.1, 1],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut"
    }
  }
};

// Bounce Animation Variants
export const bounceVariants = {
  animate: {
    y: [0, -10, 0],
    transition: {
      duration: 1,
      repeat: Infinity,
      ease: "easeInOut"
    }
  }
};

// Floating Icon Animation Variants (constant animation with box shadow and movement)
export const floatingIconVariants = {
  animate: {
    y: [0, -8, 0],
    filter: [
      "drop-shadow(0 5px 15px rgba(40, 55, 130, 0.2))",
      "drop-shadow(0 10px 25px rgba(40, 55, 130, 0.4))",
      "drop-shadow(0 5px 15px rgba(40, 55, 130, 0.2))"
    ],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut"
    }
  }
};

// FAQ Section Animation Variants
export const faqContainerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};

export const faqItemVariants = {
  hidden: { 
    opacity: 0, 
    y: 30,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.3,
      ease: "easeOut"
    }
  },
  hover: {
    y: -3,
    boxShadow: "0 10px 40px rgba(40, 55, 130, 0.4)",
    transition: {
      duration: 0.2,
      ease: "easeInOut"
    }
  }
};

export const faqAnswerVariants = {
  hidden: {
    opacity: 0,
    height: 0,
    transition: {
      duration: 0.2,
      ease: "easeInOut"
    }
  },
  visible: {
    opacity: 1,
    height: "auto",
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};

// Slide Animation Variants
export const slideInLeft = {
  hidden: { x: 0, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

export const slideInRight = {
  hidden: { x: 0, opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

// Scale Animation Variants
export const scaleIn = {
  hidden: { scale: 0, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

export const scaleOut = {
  hidden: { scale: 1, opacity: 1 },
  visible: {
    scale: 0,
    opacity: 0,
    transition: {
      duration: 0.4,
      ease: "easeIn"
    }
  }
};

// Utility Functions
export const getStaggerDelay = (index, delay = 0.1) => ({
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      delay: index * delay
    }
  }
});

export const getHoverEffect = (scale = 1.05, y = -5) => ({
  hover: {
    scale,
    y,
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
});

// Export all animations as a single object for easy importing
export const animations = {
  fadeInUp,
  fadeInDown,
  fadeInLeft,
  fadeInRight,
  cardVariantsLeft,
  cardVariantsRight,
  cardVariants,
  hoverVariants,
  textVariants,
  listItemVariants,
  factorItemHover,
  exampleBoxHover,
  staggerContainer,
  staggerItem,
  hoverScale,
  hoverLift,
  hoverRotate,
  cardHover,
  textStagger,
  buttonVariants,
  iconVariants,
  pageVariants,
  modalVariants,
  loadingVariants,
  pulseVariants,
  bounceVariants,
  slideInLeft,
  slideInRight,
  scaleIn,
  scaleOut,
  floatingIconVariants,
  faqContainerVariants,
  faqItemVariants,
  faqAnswerVariants
};

